export const LOCATION_AUTOCOMPLETE_PLACEHOLDER = "Where to?";
export const MISSING_INFO_SEARCH_ERROR =
  "To continue, please complete all required fields.";

export const SEARCH_DATES_LABEL = "When?";
export const DONE_BUTTON_TEXT = "Done";
export const DESKTOP_CALENDAR_TITLE_RANGE =
  "Select a date or date range for your activity";
